import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Configuration } from '@app/shared/models/Configuration.model';
import * as jwtDecoder from 'jwt-decode';
import { BehaviorSubject, firstValueFrom, Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';

@Injectable()
export class Adb2cService {
   constructor(private http: HttpClient) {
      this.getUser = this._getUser;
   }

   public getUser: any = null;
   public _user: any = new BehaviorSubject(null);
   public activeUser: any = new BehaviorSubject(null);

   private cachedAccessToken: string | null = null;
   private tokenExpiryTime: number | null = null;
   private tokenRequest$: Observable<string> | null = null;

   private _getUser = (token: boolean = false) => {
      // get the access token via account api
      firstValueFrom(this.http.get(`https://${window.location.host}/claims/access_token`, { responseType: 'text' })).then(
         (claim: any) => {
            // this.cacheAccessTokenInSession(claim);
            this.activeUser.next(jwtDecoder.jwtDecode(claim, { header: false }));

            if (token) {
               return new Promise((resolve) => {
                  resolve(claim);
               });
            }
            return new Promise((resolve) => {
               resolve(jwtDecoder.jwtDecode(claim, { header: false }));
            });
         },
         (err: Error) => {
            console.error("_getUser: couldn't get user...");
            console.error(err);
            return Promise.reject(err);
         }
      );
   };

   // private cacheAccessTokenInSession = (accessToken: any) => {
   //     // const fiveMinutes = 5 * 60 * 1000;

   //     // user.cache_expires_at = new Date((user.expires_at * 1000) - fiveMinutes);
   //     // console.log("_getUser: cache user to expire at  " + user.cache_expires_at.toString());

   //     sessionStorage.setItem("adb2c_access_token", JSON.stringify(accessToken));
   // };

   // private getUserFromSessionStorage() {
   //     console.log("_getUser: checking sessionState for cached user");
   //     const json = sessionStorage.getItem("adb2c_access_token");
   //     if (json != null) {
   //         console.log("_getUser: user found in sessionStorage");
   //         const user = JSON.parse(json);

   //         // if (user.cache_expires_at == null || Date.now > user.cache_expires_at) {
   //         //     console.log("_getUser: cached token is expired");
   //         //     sessionStorage.removeItem("adb2c_access_token");
   //         //     return null;
   //         // }
   //         console.log("_getUser: loaded from sessionStorage");
   //         return user;

   //     }
   //     console.log("_getUser: user is not cached in session storage")
   //     return null;

   // }

   /**
    * Gets the access token with caching support.
    * Returns cached token if valid, otherwise fetches a fresh one.
    * Uses shareReplay to prevent multiple simultaneous requests.
    */
   public getAccessToken(): Observable<string> {
      // Check if we have a cached token and it's still valid
      if (this.cachedAccessToken && this.tokenExpiryTime && Date.now() < this.tokenExpiryTime) {
         const expiryDate = new Date(this.tokenExpiryTime).toLocaleTimeString();
         console.log(`[ADB2C] Using cached access token (expires at ${expiryDate})`);
         return of(this.cachedAccessToken);
      }

      // Check if there's already an in-flight request
      if (this.tokenRequest$) {
         console.log('[ADB2C] Reusing in-flight token request...');
         return this.tokenRequest$;
      }

      // Token is missing or expired, fetch a fresh one
      console.log('[ADB2C] Fetching fresh access token from server...');
      this.tokenRequest$ = this.http.get(`https://${window.location.host}/claims/access_token`, { responseType: 'text' }).pipe(
         tap((token: string) => {
            // Cache the token
            this.cachedAccessToken = token;

            // Decode JWT to get expiry time
            try {
               const decoded: any = jwtDecoder.jwtDecode(token);
               if (decoded.exp) {
                  // Set expiry with 5-minute buffer (refresh before actual expiry)
                  const bufferSeconds = 5 * 60;
                  this.tokenExpiryTime = (decoded.exp * 1000) - (bufferSeconds * 1000);

                  const expiryDate = new Date(this.tokenExpiryTime).toLocaleTimeString();
                  console.log(`[ADB2C] Fresh access token cached (expires at ${expiryDate})`);
               } else {
                  console.warn('[ADB2C] Token does not contain exp claim, caching for 10 minutes');
                  this.tokenExpiryTime = Date.now() + (10 * 60 * 1000);
                  const expiryDate = new Date(this.tokenExpiryTime).toLocaleTimeString();
                  console.log(`[ADB2C] Fresh access token cached (expires at ${expiryDate})`);
               }
            } catch (error) {
               console.error('[ADB2C] Failed to decode token for expiry check:', error);
               // Default to 10 minutes if we can't decode
               this.tokenExpiryTime = Date.now() + (10 * 60 * 1000);
               const expiryDate = new Date(this.tokenExpiryTime).toLocaleTimeString();
               console.log(`[ADB2C] Fresh access token cached with fallback (expires at ${expiryDate})`);
            }

            // Clear the in-flight request tracker
            this.tokenRequest$ = null;
         }),
         shareReplay(1)
      );

      return this.tokenRequest$;
   }
}

export class UserNotFound {
   'not' = 'found';
   'access_token' = '';
}
